import MapDisplayModes from 'aria-viewer/map/MapDisplayModes'
import pure from 'recompose/pure'
import { showSupplementalMediaPreview } from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import SupplementalMediaDesktop from 'aria-viewer/players/supplementalmedia/components/supplementalMediaDesktop'
import { setElapsedTime } from 'aria-viewer/analytics/analyticActions'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import MainMediaManager from 'aria-viewer/media/components/mainMediaManager'
import { LoadingScreen } from 'aria-viewer/loadingscreen'
import Navigation from 'aria-viewer/navigation/navigation'
import Avatar from 'aria-viewer/guide/components/Avatar'
import Drawer from 'aria-viewer/drawer/drawer'
import ToursList from './toursList'
import TourButtons, { RIGHT_TOP, BOTTOM_RIGHT, BOTTOM_LEFT } from './tourButtons'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import LocationTitleButton from 'aria-viewer/tour/components/buttons/LocationTitleButton'
import ContextMenuIndex from 'aria-viewer/contextmenu/'
import ContextMenuManager from 'aria-viewer/contextmenu/components/ContextMenuManager'
import StopsList from 'aria-viewer/stopselector/containers/StopsList'
import StopDescription from 'aria-viewer/stopselector/containers/StopDescription'
import { PaymentsModuleContainer } from 'aria-viewer/payments'
import { setRegistrationEnabled } from 'aria-viewer/tour/tourActions'

import {
    TOUR_DRAWER,
    VR_INSTRUCTION_DRAWER,
    STOP_DESCRIPTION_DRAWER,
    showVRInstructionDrawer,
    hideDrawer,
} from 'aria-viewer/drawer/drawerMenuActions'
import { StopTitle } from 'aria-viewer/stopselector'
import Logo from 'aria-viewer/tour/components/logo'
import { setActionButtons, setTourExpanded, setTourLoadingStatus } from '../tourActions'
import DrawerFader from 'aria-viewer/drawer/drawerFader'
import VRInstructionsPanel from './panel/vrInstructionsPanel'
import ModalsContainer from 'aria-viewer/modal/components/modalsContainer'
import ModalIndex from 'aria-viewer/modal/components/index'
import BrowserNotSupported from 'aria-viewer/tour/components/browserNotSupported'
import Browser from 'aria-viewer/utils/mobileDetect'
import OfflineExperience from 'aria-viewer/tour/containers/OfflineExperience'
import AutoPlay from '../components/autoplay'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import { NextButton } from 'aria-viewer/navigation'
import withDeviceDimensions from 'aria-viewer/device/WithDeviceDimensions'
import InteractiveElementsListContainer from 'aria-viewer/interactive-element/containers/elements_list/InteractiveElementsList'
import { delay } from '../../utils/functions'
import { Stats, FPSMeter } from 'aria-viewer/stats'
import { isFullScreenActive, requestFullScreen, exitFullScreen } from 'aria-viewer/utils/fullScreen'

import MobileAudioHandler from 'aria-viewer/audiomanager/components/MobileAudioHandler'
import { setAutoPlay, playAudio, AUDIO_TOUR, stopAudio } from 'aria-viewer/audiomanager/audioManagerActions'
import { Icon } from 'aria-viewer/common/components/Icon'
import MobileDetect from 'aria-viewer/utils/mobileDetect'
import { WithEventListener } from 'aria-viewer/common'
import { withOptions } from 'react-event-listener'
import { pausePositionalMediaPlayers } from 'aria-viewer/interactive-element/actions/positionalMediaActions'

import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import { closeModal } from 'aria-viewer/modal/modalActions'

import {
    Capabilities,
    convertCapabilitiesConfigToValue,
    getCapabilityConfig,
    displayFeatureBasedOnViewportSize,
} from 'aria-viewer/utils/capabilities'
import URI from 'aria-viewer/utils/uriHandler'

import InquiryFormModal from 'aria-viewer/common/components/InquiryFormModal'

const NavigationPanel = pure(function NavigationPanel({ onTop, sizes }) {
    return <Navigation />
})

const S = {
    iframeBackdropContainer: {
        backgroundColor: 'black',
        zIndex: '9999',
        opacity: 0.5,
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
    },
    iframeContainer: {
        position: 'absolute',
        width: '90%',
        height: '90%',
        backgroundColor: 'white',
        zIndex: '10000',
        left: '5%',
        top: '5%',
        opacity: 1.0,
    },
    registrationIframe: {
        width: '100%',
        height: '100%',
        borderWidth: '0px',
        opacity: 1.0,
    },
    opacityHelper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'transparent',
        zIndex: 8,
        transform: `translate3d(0, 0, 1px)`,
    },
    navigation: {
        position: 'absolute',
        bottom: '3.5em',
        left: '50%',
        transform: 'translateX(-50%)',
        WebkitBackfaceVisibility: 'hidden',
        zIndex: 5,
        height: '6.2em',
    },
    mainUILeftDrawer: {
        background: 'none',
    },
    mainUITopDrawer: {
        background: 'none',
        top: '-1.2em',
    },
    loadingScreen: {
        position: {
            textAlign: 'center',
        },
        loaderPosition: {
            height: '25vw',
        },
        image: {
            width: '20vw',
        },
        spinner: {
            width: '15vw',
            height: '15vw',
        },
    },
    mainContentWrapper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
    stopDescriptionDrawer: {
        backgroundColor: 'rgba(30, 39, 59, 0.9)',
    },
    mainUIRight: {
        mediaPreview: {
            background: 'none',
            right: 0,
            left: null,
            zIndex: 8,
        },
        noMediaPreview: {
            background: 'none',
            right: 0,
            left: null,
            zIndex: 5,
        },
    },
    rightShadowDrawer: {
        background: 'none',
        left: null,
        right: 0,
        bottom: 0,
        boxShadow: 'rgba(0, 0, 0, 0.5) -15px 0 20px -6px inset',
    },
    drawerFaderInstructionPanel: {
        right: 0,
        left: null,
    },
    tourDrawer: { backgroundColor: 'rgba(8, 19, 30, 0.9)', zIndex: 2005 },
    noPadding: {
        padding: '0',
    },
    tourButtonResponsive: {
        position: 'relative',
        width: '100%',
        top: '0.3em',
        right: '-130px',
        '& div.actionButtons': {
            backgroundColor: 'grey',
        },
        '& > .actionButtons > a': {
            marginRight: '0px',
            padding: '0.3em 0px',
            width: '5.5em',
        },
    },
    logoStyle: {
        container: {
            marginTop: 0,
            zIndex: 2001,
            bottom: 15,
            left: 15,
            position: 'absolute',
        },
        poweredBy: {
            color: 'white',
        },
    },
    mainUITopContainer: {
        position: 'absolute',
        top: '0px',
        height: '3.7em',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
    },
}

const styles = {
    interactiveElementsList: {
        position: 'absolute',
        bottom: ({ isMapEnabled }) => (isMapEnabled ? 250 : 80),
        zIndex: 2000,
        left: 10,
        transition: 'left 0.25s ease-out, height 0.5s, width 0.5s, border-radius 0.2s ease-in 0.2s, bottom 0.5s ease',
        '&.expanded': {
            left: 0,
            bottom: 80,
            zIndex: 2000,
            transition: 'left 0.25s ease-out, height 0.5s, width 0.5s, bottom 0.5s ease',
        },
    },
    locationButton: {
        position: 'absolute',
        top: '0.95em',
        left: '1.5em',
        zIndex: 1999,
        fontWeight: 400,
        lineHeight: 1.55,
        textShadow: '0 0 3px rgba(0, 0, 0, 0.3)',
        animationName: 'fadeIn',
        animationFillMode: 'forwards',
        animationDuration: '0.3s',
    },

    nextButton: {
        position: 'absolute',
        transform: 'translateY(-50%)',
        justifyContent: 'space-between',
        display: 'flex',
        zIndex: 100,
        right: ({ viewportWidth }) => (viewportWidth < 700 ? 16 : 32),
        userSelect: 'none',
        justifyContent: 'space-between',
        alignItems: 'center',
        animationName: 'fadeIn',
        animationFillMode: 'forwards',
        animationDuration: '0.3s',
        top: '50%',
    },
    '@keyframes fadeIn': {
        '0%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
    offlineExperience: {
        position: 'absolute',
        zIndex: 3000,
    },
}

const noop = _ => null

class AriaViewerEmbed extends PureComponent {
    static contextTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
    }

    constructor(props) {
        super(props)

        this.elapsedTime = 10000
        this.state = {
            closeStopDrawFader: false,
            isTourloadedViaLinkChange: false,
            ready: false,
            leftReady: false,
            rightReady: false,
            topReady: false,
            drawerReady: false,
            expanded: false,
            regFinished: false,
        }

        setTimeout(() => {
            props.setElapsedTime(this.elapsedTime)
        }, this.elapsedTime)
    }

    componentWillReceiveProps(nextProps, nextState) {
        const { setTourLoadingStatus } = this.props
        /*
		This only gets called when it's a singleMedia tour
		 */
        const { isSingleMedia, loading, altMainMedia, mainMediaInitialized } = nextProps

        if (this.state.isTourloadedViaLinkChange) {
            this.setState({ isTourloadedViaLinkChange: false })
        }
        if (!this.props.mainMediaInitialized && mainMediaInitialized) {
            setTourLoadingStatus(false)
            return this.setReady()
        }
        if (this.props.isRegistrationOpen != nextProps.isRegistrationOpen && nextProps.isRegistrationOpen) {
            this.onRegistrationOpened(nextProps)
        }
    }

    processPostMessage = event => {
        const { isAndroid } = this.props
        switch (event.data) {
            case 'experience::stopmedia':
                //console.log('responding to: data::stopplayback')
                this.props.stopAudio(AUDIO_TOUR)
                break
            case 'data::expanded':
                //console.log("Recieved message: data::expanded")
                this.props.playAudio(AUDIO_TOUR)
                this.setExpanded(true)
                if (isAndroid) {
                    requestFullScreen()
                }
                break
            case 'data::collapsed':
                //console.log("Recieved message: data::collapsed")
                this.props.stopAudio(AUDIO_TOUR)
                this.props.pausePositionalMediaPlayers()
                this.setExpanded(false)
                break
        }
    }

    setExpanded = expanded => {
        this.setState({ expanded })
        this.props.setTourExpanded(expanded)
    }

    handleMouseExitExperience = event => {
        this.props.stopAudio(AUDIO_TOUR)
    }

    closeReg = () => {
        this.setState({
            regFinished: true,
        })
    }

    componentDidMount() {
        this.props.mainMediaInitialized && this.setReady()

        // listen to postMessage events in order to adapt the UI to certain scenarios
        window.addEventListener('message', this.processPostMessage, false)

        document.addEventListener(
            'keydown',
            event => {
                if (!isFullScreenActive()) {
                    return
                }
                const keyName = event.key

                if (keyName === 'Escape') {
                    // do not alert when only Control key is pressed.
                    exitFullScreen()
                    return
                }
            },
            false
        )
    }

    componentWillUnmount() {
        // remove the message listener user for postMessage events
        window.removeEventListener('message', this.processPostMessage)

        // remove keypress listener
        document.removeEventListener('keydown', this.processPostMessage)
    }

    setReady = async () => {
        await delay(1000).then(() => requestAnimationFrame(() => this.setState({ ready: true })))
        await delay(500).then(() => requestAnimationFrame(() => this.setState({ rightReady: true })))
        await delay(750).then(() => requestAnimationFrame(() => this.setState({ leftReady: true })))
        await delay(1000).then(() => requestAnimationFrame(() => this.setState({ drawerReady: true })))
        // await this.delay(1000).then(() => requestAnimationFrame(() => this.props.setActionButtons({visible: true})))
    }

    get sizes() {
        return {
            width: this.props.viewportWidth,
            height: this.props.viewportHeight,
        }
    }

    handleOnStopDrawerClose = params => {
        if (params && params.hasIntro) {
            //if intro present call the tourlistclose function
            this.handleOnTourListClose()
        }
    }

    handleOnTourListClose = () => {
        this.props.hideDrawer()
    }

    handleOnLinkChange = () => {
        this.setState({ isTourloadedViaLinkChange: true })
    }

    getNavigation = () => {
        if (this.props.isWalkingtour || this.props.isHybridtour) {
            return <Navigation style={S.navigation} sizes={this.sizes} />
        }
    }

    getVRInstructionPanel = () => {
        return <VRInstructionsPanel />
    }

    toursList = () => {
        return (
            <ToursList
                title="Select an Experience"
                closeButton={true}
                width={540}
                height={300}
                onClose={this.handleOnTourListClose}
                onLinkChange={this.handleOnLinkChange}
            />
        )
    }

    onRegistrationOpened = ({ viewportHeight, viewportWidth }) => {
        if (
            displayFeatureBasedOnViewportSize(Capabilities.FULL_SCREEN_REG, {
                viewportHeight,
                viewportWidth,
            })
        ) {
            requestFullScreen()
        }
    }

    getMainUITop = (viewportHeight, viewportWidth) => {
        const { capabilityConfig } = this.props
        const { expanded } = this.state

        return (
            <div className={'main-ui-top'} style={S.mainUITopContainer}>
                {capabilityConfig[Capabilities.LOCATION_TITLE] &&
                    (displayFeatureBasedOnViewportSize(Capabilities.LOCATION_TITLE, {
                        viewportHeight,
                        viewportWidth,
                    }) ||
                        expanded) && (
                        <LocationTitleButton className={this.props.classes.locationButton} useResponsiveUI={true} />
                    )}
                {capabilityConfig[Capabilities.STOP_TITLE] &&
                    (displayFeatureBasedOnViewportSize(Capabilities.STOP_TITLE, { viewportHeight, viewportWidth }) ||
                        expanded) && <StopTitle isInIframe={true} />}
                <div className={'responsive-wrapper'} style={S.tourButtonResponsive}>
                    {displayFeatureBasedOnViewportSize(Capabilities.TOUR_BUTTONS, {
                        viewportHeight,
                        viewportWidth,
                    }) && (
                        <TourButtons
                            isInExpandedState={this.state.expanded}
                            containerPosition={RIGHT_TOP}
                            sizes={this.sizes}
                            useResponsiveUI={true}
                            setExpanded={this.setExpanded}
                        />
                    )}
                </div>
            </div>
        )
    }

    getMainUILeft = (viewportHeight, viewportWidth) => {
        return (
            <div>
                <TourButtons
                    isInExpandedState={this.state.expanded}
                    containerPosition={BOTTOM_LEFT}
                    sizes={this.sizes}
                    useResponsiveUI={true}
                    setExpanded={this.setExpanded}
                />

                {/* <MapFloatingContainer sizes={this.sizes} /> */}

                {this.props.hasMultipleStops && <StopsList {...this.sizes} />}

                <InteractiveElementsListContainer className={this.props.classes.interactiveElementsList} />
            </div>
        )
    }

    getMainUIRight = (viewportHeight, viewportWidth) => {
        return (
            <div style={S.noPadding}>
                <TourButtons
                    isInExpandedState={this.state.expanded}
                    containerPosition={BOTTOM_RIGHT}
                    sizes={this.sizes}
                    useResponsiveUI={true}
                    setExpanded={this.setExpanded}
                />
            </div>
        )
    }

    handleSupMediaPreviewVisible = () => {
        const { supplementalMediaPreviewVisible, showSupplementalMediaPreview } = this.props
        return supplementalMediaPreviewVisible ? showSupplementalMediaPreview(false) : null
    }

    getOverlay = () => {
        return (
            !Browser.mobile() && (
                <OpacityHelper
                    onClick={this.handleSupMediaPreviewVisible}
                    test={this.props.supplementalMediaPreviewVisible}
                    style={S.opacityHelper}
                >
                    {noop}
                </OpacityHelper>
            )
        )
    }

    getMainUI = (viewportHeight, viewportWidth) => {
        const { isSingleMedia, loading, supplementalMediaPreviewVisible, capabilityConfig } = this.props
        //dont include drawers if it's a single media
        return isSingleMedia ? (
            <div
                style={{
                    display: this.showMainUI && !loading ? 'block' : 'none',
                }}
            >
                {this.getMainUIRight(viewportHeight, viewportWidth)}
                {!this.props.loadSingleStopOnly &&
                    capabilityConfig[Capabilities.MAIN_NAV] &&
                    this.getMainUILeft(viewportHeight, viewportWidth)}
                {this.getMainUITop(viewportHeight, viewportWidth)}
            </div>
        ) : (
            // TODO: Factor out MainUI into separate mobile
            // and desktop components. Create individual pure
            // UI components like RightUIDrawer, LeftUIDrawer, etc.

            // Ideally should be an individual component
            <div>
                {this.getOverlay()}
                <div>
                    <Drawer
                        ignoreUnmount={true}
                        location="right"
                        open={this.showMainUI}
                        width={250}
                        style={
                            supplementalMediaPreviewVisible ? S.mainUIRight.mediaPreview : S.mainUIRight.noMediaPreview
                        }
                        height={1}
                        boxShadow={false}
                    >
                        {this.state.rightReady && this.getMainUIRight(viewportHeight, viewportWidth)}
                    </Drawer>
                </div>
                {capabilityConfig[Capabilities.MAIN_NAV] && (
                    <Drawer
                        ignoreUnmount={true}
                        location="left"
                        open={this.showMainUI || this.props.mapDisplayMode === MapDisplayModes.FULLSCREEN}
                        width={250}
                        style={S.mainUILeftDrawer}
                        boxShadow={false}
                    >
                        {!this.props.loadSingleStopOnly &&
                            this.state.leftReady &&
                            this.getMainUILeft(viewportHeight, viewportWidth)}
                    </Drawer>
                )}
                <Drawer location="top" open={this.showMainUI} style={S.mainUITopDrawer} height={1} boxShadow={false}>
                    {this.getMainUITop(viewportHeight, viewportWidth)}
                </Drawer>
            </div>
        )
    }

    getMainContent = (viewportHeight, viewportWidth) => {
        const { loadSingleStopOnly, hasMultipleStops, isInIframe, capabilityConfig } = this.props
        return (
            <div style={S.mainContentWrapper}>
                <LoadingScreen class="gray" style={S.loadingScreen} />
                <MainMediaManager embed={isInIframe} positionalmedia={true} sizes={this.sizes} style={this.sizes} />
                {capabilityConfig[Capabilities.MAIN_NAV] && !loadSingleStopOnly && this.getNavigation()}
                {capabilityConfig[Capabilities.MAIN_UI] &&
                    this.showMainUI &&
                    this.state.ready &&
                    this.getMainUI(viewportHeight, viewportWidth)}
                {capabilityConfig[Capabilities.GUIDE] && <Avatar {...this.sizes} useResponsiveUI={true} />}}
                {capabilityConfig[Capabilities.SIDE_NAV] && !loadSingleStopOnly && (
                    <Drawer name={TOUR_DRAWER} location="top" style={S.tourDrawer}>
                        {this.toursList}
                    </Drawer>
                )}
                <Drawer style={S.stopDescriptionDrawer} name={STOP_DESCRIPTION_DRAWER} location="right">
                    <StopDescription />
                </Drawer>
                {capabilityConfig[Capabilities.VR_INSTRUCTIONS] && (
                    <DrawerFader
                        style={S.drawerFaderInstructionPanel}
                        name={VR_INSTRUCTION_DRAWER}
                        location="right"
                        width={400}
                        autoHide={false}
                        hideOnOverlayClick={true}
                    >
                        {this.getVRInstructionPanel}
                    </DrawerFader>
                )}
                {
                    <Logo
                        containerStyle={S.logoStyle.container}
                        poweredByStyle={S.logoStyle.poweredBy}
                        useResponsiveUI={true}
                    />
                }
            </div>
        )
    }

    render() {
        const {
            altMainMedia,
            isVideoUIVisible,
            isPanoUIVisible,
            mainMediaInitialized,
            classes,
            capabilityConfig,
            hasMultipleStops,
            viewportHeight,
            viewportWidth,
        } = this.props

        const { expanded } = this.state
        const isMobile = MobileDetect.mobile()

        this.showMainUI =
            (isMobile ? expanded : true) &&
            !altMainMedia &&
            mainMediaInitialized &&
            ((this.props.mainMedia.mediaType === 'video' && isVideoUIVisible) ||
                (this.props.mainMedia.mediaType === 'panorama' && isPanoUIVisible) ||
                this.props.mainMedia.mediaType === 'photo')

        const isMobileAndExpanded = expanded && isMobile

        const displayNextButton =
            isMobileAndExpanded ||
            displayFeatureBasedOnViewportSize(Capabilities.NEXT_BUTTON, {
                viewportHeight,
                viewportWidth,
            })

        return (
            this.props.tourLoading && (
                <ContextMenuManager registry={ContextMenuIndex}>
                    <div
                        style={{
                            position: 'fixed',
                            left: 3,
                            bottom: 1,
                            color: 'rgba(255,255,255,.5)',
                            fontSize: '8pt',
                            zIndex: 999,
                        }}
                    >
                        {this.props.appVersion}
                    </div>
                    <Stats />
                    <FPSMeter />
                    <MobileAudioHandler />
                    <AutoPlay />
                    <SupplementalMediaDesktop />

                    {this.props.isRegistrationOpen && this.props.isCIFForm && (
                        <InquiryFormModal
                            onClose={completed => {
                                isFullScreenActive() && exitFullScreen()
                            }}
                            hasBorder={isFullScreenActive() ? true : false}
                        />
                    )}

                    <ModalsContainer desktop={true} registry={ModalIndex} />
                    {this.getMainContent(viewportHeight, viewportWidth)}

                    {/* <StopTitleToast sizes={this.sizes} /> */}
                    {this.showMainUI &&
                        capabilityConfig[Capabilities.NEXT_BUTTON] &&
                        displayNextButton &&
                        this.state.ready &&
                        hasMultipleStops && <NextButton className={classes.nextButton} />}
                    <BrowserNotSupported />
                    <OfflineExperience className={classes.offlineExperience} />
                    <PaymentsModuleContainer />

                    {isMobile && !expanded && (
                        <div
                            style={{ position: 'absolute', bottom: 0, right: 5, color: 'white' }}
                            onClick={() => {
                                isMobile && exitFullScreen()
                            }}
                            onTouch={() => {
                                isMobile && exitFullScreen()
                            }}
                        >
                            <Icon>fullscreen</Icon>
                        </div>
                    )}
                </ContextMenuManager>
            )
        )
    }
}

let capabilitiesConfigValue = URI.getParamValue('capabilities')
let defaulCapabilitiesConfigValue = convertCapabilitiesConfigToValue({
    [Capabilities.MAIN_UI]: true,
    [Capabilities.MAIN_NAV]: false,
    [Capabilities.SIDE_NAV]: false,
    [Capabilities.VR_INSTRUCTIONS]: true,
    [Capabilities.SUPPLEMENTAL_MEDIA_DESKTOP]: true,
    [Capabilities.NEXT_BUTTON]: true,
    [Capabilities.REGISTRATION]: true,
    [Capabilities.GUIDE]: true,
    [Capabilities.TOUR_BUTTONS]: true, // Incomplete
    [Capabilities.INTERACTIVE_ELEMENTS_LIST]: true,
    [Capabilities.LOCATION_TITLE]: false,
    [Capabilities.STOP_TITLE]: true,
})

if (URI.hasQueryParam('capabilities')) {
    capabilitiesConfigValue = parseInt(URI.getParamValue('capabilities'))
    // Bitwise AND capabilities config with system generated, gets allowed config
    capabilitiesConfigValue = capabilitiesConfigValue & defaulCapabilitiesConfigValue
} else if (URI.hasQueryParam('disabledCapabilities')) {
    capabilitiesConfigValue = parseInt(URI.getParamValue('disabledCapabilities'))
    // Bitwise XOR capabilities config with system generated, get allowed config - disabledCapabilities
    capabilitiesConfigValue = capabilitiesConfigValue ^ defaulCapabilitiesConfigValue
} else {
    capabilitiesConfigValue = defaulCapabilitiesConfigValue
}

export default compose(
    connect(state => {
        return {
            capabilityConfig: getCapabilityConfig(capabilitiesConfigValue),
            viewportWidth: state.getIn(['device', 'viewportWidth']),
            viewportHeight: state.getIn(['device', 'viewportHeight']),
            isAndroid: state.getIn(['device', 'isDeviceAndroid']),
            appVersion: state.getIn(['device', 'appVersion']),
            isCIFForm: state.getIn(['registration', 'formType']) == 'cif',
            isRegistrationOpen: state
                .getIn(['modal', 'modalStack'])
                .some(modal =>
                    [ModalContentTypes.WELCOME_REGISTRATION, ModalContentTypes.REGISTRATION].includes(
                        modal.content.type
                    )
                ),
        }
    }),
    connect(
        mapSelectorsToProps([
            'mapDisplayMode',
            'isWalkingtour',
            'isHybridtour',
            'isMediatour',
            'isSingleMedia',
            'loadSingleStopOnly',
            'supplementalMediaPreviewVisible',
            'loading',
            'tourLoading',
            'mainMedia',
            'mainMediaInitialized',
            'altMainMedia',
            'isRegistrationEnabled',
            'hasMultipleStops',
            'isVideoUIVisible',
            'isPanoUIVisible',
            'viewportWidth',
            'viewportHeight',
            'isMapEnabled',
            'isInIframe',
        ]),
        {
            showVRInstructionDrawer,
            showSupplementalMediaPreview,
            hideDrawer,
            setActionButtons,
            setElapsedTime,
            playAudio,
            setAutoPlay,
            stopAudio,
            pausePositionalMediaPlayers,
            setTourExpanded,
            setTourLoadingStatus,
            closeModal,
            setRegistrationEnabled,
        }
    ),
    WithEventListener({
        target: document,
        onMouseLeave: props => e => {
            // If the mouse leaves the experience (inline0embed) stop the audio
            props.stopAudio(AUDIO_TOUR)
            props.pausePositionalMediaPlayers()
        },
        onMouseEnter: props => e => {
            // based on capability, play audio when mouse enters experience?
            //props.playAudio(AUDIO_TOUR)
        },
        onClick: props =>
            withOptions(
                e => {
                    if (!props.autoplay) {
                        props.setAutoPlay(!props.autoplay)
                        props.playAudio(AUDIO_TOUR)
                    }
                },
                {
                    once: true,
                }
            ),
    }),
    withDeviceDimensions,
    injectJss(styles)
)(AriaViewerEmbed)
